import { FilterChipDto, StrankaMultiSelectItem } from '@kodit/core/data-api';

export interface ISefObavestenjeFilter {
  dateFrom?: Date;
  dateTo?: Date;
  searchTerm?: string;
  stranke?: StrankaMultiSelectItem[];
}

export function buildSefObavestenjeChips(
  filters: ISefObavestenjeFilter,
  strankaLabel: string
): FilterChipDto[] {
  const chips: FilterChipDto[] = [];

  if (filters.searchTerm) {
    chips.push(new FilterChipDto({ key: 'searchTerm', value: `Pretraga: ${filters.searchTerm}`, defaultValue: null }));
  }
  if (filters.stranke?.length) {
    filters.stranke.forEach((s) =>
      chips.push(new FilterChipDto({ key: 'stranke', value: `${strankaLabel}: ${s.naziv}`, defaultValue: null }))
    );
  }
  if (filters.dateFrom) {
    chips.push(new FilterChipDto({
      key: 'dateFrom',
      value: `Datum od: ${new Date(filters.dateFrom).toLocaleDateString('sr-Latn-RS')}`,
      defaultValue: null,
    }));
  }
  if (filters.dateTo) {
    chips.push(new FilterChipDto({
      key: 'dateTo',
      value: `Datum do: ${new Date(filters.dateTo).toLocaleDateString('sr-Latn-RS')}`,
      defaultValue: null,
    }));
  }

  return chips;
}

export function hasSefObavestenjeActiveFilters(filters: ISefObavestenjeFilter): boolean {
  return !!(
    filters.searchTerm ||
    filters.stranke?.length ||
    filters.dateFrom ||
    filters.dateTo
  );
}
